export default '/alerts';
